import React, { useState } from "react";
import { Row, Col, Breadcrumb, Card } from "react-bootstrap";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import "../../assets/css/brandbook.css";
import { Calendar } from "primereact/calendar";

const AddPostData = () => {
    const navigate = useNavigate();
    const [cards, setCards] = useState([
        {
            id: Date.now(),
            day: "",
            postType: "",
            topic: "",
            visual: "",
            copy: "",
            caption: "",
            hashtags: "",
            internalFeedback: "",
            clientFeedback: ""
        }
    ]);

    // Add a new card
    const addCard = () => {
        setCards([
            ...cards,
            {
                id: Date.now(),
                day: "",
                postType: "",
                topic: "",
                visual: "",
                copy: "",
                caption: "",
                hashtags: "",
                internalFeedback: "",
                clientFeedback: ""
            }
        ]);
    };

    // Remove a card
    const removeCard = (id) => {
        setCards(cards.filter(card => card.id !== id));
    };

    // Handle input change
    const handleInputChange = (id, field, value) => {
        setCards(cards.map(card => (card.id === id ? { ...card, [field]: value } : card)));
    };

    const formatDateWithWeekday = (date) => {
        if (!date) return "";
        return new Intl.DateTimeFormat("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" }).format(date);
    };

    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col lg={12} className="mb-4 d-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                <i className="pi pi-angle-left"></i> Back
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Add Data</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-0 sticky-top  bg-white px-4 py-3 shadow-sm" style={{ top: '-36px' }}>
                            <h6 className="fw-bold mb-0">Brand Name</h6>
                            <Button 
                                label="Row" 
                                icon="pi pi-plus"
                                severity="warning"
                                className="border-0 py-2" 
                                onClick={addCard}

                            />
                        </div>
                        <Row className="mx-0">
                            {cards.map((card, index) => (
                                <Col lg={12} md={12} key={card.id} className="mb-3 p-0">
                                    <Card className="p-0 shadow-sm">
                                        <Card.Header className="h6 d-flex justify-content-between align-items-center"> 
                                            Post {index + 1}
                                            <div>
                                                {cards.length > 1 && (
                                                    <Button
                                                        title="Remove Card"
                                                        icon="pi pi-times"
                                                        className="p-button-danger p-button-text"
                                                        onClick={() => removeCard(card.id)}
                                                    />
                                                )}
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <Row>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Day</label>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <Calendar
                                                            value={card.day ? new Date(card.day) : null}
                                                            placeholder="Select a date"
                                                            onChange={(e) => handleInputChange(card.id, "day", e.value)}
                                                            dateFormat="dd/mm/yy"
                                                            showWeek
                                                        />
                                                        <small className="text-secondary ms-2">
                                                            {card.day ? formatDateWithWeekday(new Date(card.day)) : ""}
                                                        </small>
                                                    </div>
                                                    
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Post Type</label>
                                                    <textarea
                                                        className="form-control height-auto"
                                                        rows="3"
                                                        value={card.postType}
                                                        onChange={(e) => handleInputChange(card.id, "postType", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Topic</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={card.topic}
                                                        onChange={(e) => handleInputChange(card.id, "topic", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Visual Idea + Reference</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={card.visual}
                                                        onChange={(e) => handleInputChange(card.id, "visual", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Copy</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={card.copy}
                                                        onChange={(e) => handleInputChange(card.id, "copy", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Caption</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={card.caption}
                                                        onChange={(e) => handleInputChange(card.id, "caption", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Keywords + Hashtags</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={card.hashtags}
                                                        onChange={(e) => handleInputChange(card.id, "hashtags", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Internal Feedback</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={card.internalFeedback}
                                                        onChange={(e) => handleInputChange(card.id, "internalFeedback", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                                <Col lg={4} md={6} className="mb-3">
                                                    <label className="fw-bold">Client Feedback</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={card.clientFeedback}
                                                        onChange={(e) => handleInputChange(card.id, "clientFeedback", e.target.value)}
                                                    ></textarea>
                                                </Col>
                                            </Row>

                                            {/* Action Buttons */}
                                            
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                        <div className="d-flex justify-content-end mt-3 mb-5">
                            <Button
                                icon="pi pi-save"
                                className="border-0"
                                severity="info"
                                label="Save Data"
                            />
                        </div>

                        {/* Add Card Button */}
                        
                    </Col>
                </Row>
            </Row>
        </>
    );
};

export default AddPostData;
